// src/utils/numeroOrdine.js
// «N. ordine» della commessa (W440): numero d'ordine interno dell'azienda, testo libero corto.
/** Spazi ripuliti, massimo 40 caratteri; "" se vuoto. */
export const pulisciNumeroOrdine = (t) => String(t ?? "").replace(/\s+/g, " ").trim().slice(0, 40);
/** Ordine «naturale» dei numeri d'ordine (4500123 < 4500200, "A-12" < "A-100"); vuoti in fondo. */
export function confrontaNumeroOrdine(a = "", b = "") {
  if (!a && !b) return 0; if (!a) return 1; if (!b) return -1;
  return String(a).localeCompare(String(b), "it", { numeric: true, sensitivity: "base" });
}
